import { OVERLAY_SURFACE_SELECTOR } from "./walkthroughAnchors";

/** Whether a click landed off the step: outside every zone it may legitimately go to, and outside any open menu or panel. */
const isWrongClickTarget = (node: Node, zones: readonly (Element | null)[]): boolean => {
	if (zones.some((zone) => zone?.contains(node) === true)) return false;
	// A surface the opener just revealed takes clicks that are the user following the step, not straying from it.
	const element = node instanceof Element ? node : node.parentElement;
	return element?.closest(OVERLAY_SURFACE_SELECTOR) === null;
};

/** Calls `onWrongClick` per trusted click outside `getZones()`; capture phase, so the tour overlay can't swallow it. */
export const watchWrongClicks = (getZones: () => readonly (Element | null)[], onWrongClick: () => void): (() => void) => {
	const onClick = (event: MouseEvent) => {
		if (!event.isTrusted || !(event.target instanceof Node)) return;
		if (isWrongClickTarget(event.target, getZones())) onWrongClick();
	};
	document.addEventListener("click", onClick, true);
	return () => document.removeEventListener("click", onClick, true);
};
